<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        Training Videos
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->
    <!-- Courses and Training Videos Grid Section Start -->
    <section class="section">
      <div class="container">
        <p class="pb-3">
          Project Spectrum's train the trainer course offers an in depth step-by-step guide for navigating our platform and utilizing all the resources we offer. From registering as a new user all the way to completing a cyber readiness check, this video will help you understand what you need to succeed with Project Spectrum.
        </p>
        <!-- <div class="pb-4">
          <b-form-input
            v-model="searchQuery"
            placeholder="Search Training Videos..."
          ></b-form-input>
        </div>

        <p class="pb-2" v-if="displayedItems.length === 0 && searchQuery">
          No items match the search criteria...
        </p>
        <p class="pb-2" v-if="displayedItems.length === 0 && !searchQuery">
          Check back soon for more courses and training videos...
        </p>
        <div class="blog-post-grid">
          <div class="row">
         
            <div
              class="col-md-6 col-lg-4 mb-5"
              v-for="item in displayedItems"
              :key="item.id"
            >
              <div class="blog-item border h-100">
                <a
                  :href="itemHref(item)"
                  :target="itemTarget(item)"
                  class="blog-post-image"
                >
                  <img
                    :src="item.trainingVideoThumbnailLink"
                    :alt="item.photoDescription"
                    class="cover"
                  />
                </a>
                <div
                  class="blog-post-info d-flex align-items-start flex-column"
                >
                  <h4 class="blog-post-title">
                    {{ item.title }}
                  </h4>
                  <div class="w-100">
                    <p class="truncate">{{ item.source }}</p>
                  </div>

                  <div
                    class="post-event-bottom d-flex align-items-center mt-auto"
                  >
                    <a class="blog-info-meta text-dark"
                      ><i class="mdi mdi-calendar-outline pr-1"></i
                      >{{ getFormattedDate(item.date) }}</a
                    >

                    <a class="blog-category text-dark"
                      ><i class="mdi mdi-clock-outline pr-1"></i
                      >{{ item.duration }}</a
                    >
                  </div>
                 
                  <div class="float-right-bottom" v-if="!item.isPageBookmarked">
                    <font-awesome-icon
                      id="tooltip-bookmark"
                      :icon="['far', 'bookmark']"
                      v-on:click="onBookmarkPage(item)"
                    />
                    <b-tooltip target="tooltip-bookmark" variant="primary"
                      >Click to bookmark video</b-tooltip
                    >
                  </div>
                  
                  <div class="float-right-bottom" v-else>
                    <font-awesome-icon
                      id="tooltip-bookmark"
                      :icon="['fas', 'bookmark']"
                    />
                    <b-tooltip target="tooltip-bookmark" variant="success"
                      >Bookmarked!</b-tooltip
                    >
                  </div>
                 
                  <a
                    class="blog-read-more"
                    :href="itemHref(item)"
                    :target="itemTarget(item)"
                  >
                    <i
                      class="mdi"
                      :class="isLocked(item) ? 'mdi-lock' : 'mdi-play'"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
           
          </div>
        </div>
        <div>
          <b-pagination
            id="blog-pagination"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            @page-click="pageClicked"
          ></b-pagination>
         -->
        <div class="row">
          <div class="col-12 pt-4">
            <center>
             
              <div style="position: relative; padding-top: 56.25%;"><iframe src="https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/3ac5685e37d928408f916ac55730ae0c/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F3ac5685e37d928408f916ac55730ae0c%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600" style="border: 5px outset #ddd; position: absolute; top: 0; left: 10%; height: 75%; width: 75%;" allow="accelerometer; gyroscope;  encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe></div>
             
            </center>
          </div>
      </div>
    </div>
    </section>
    <!-- Courses and Training Videos Grid Section End -->
    <!-- Login Modal -->
    <b-modal size="lg" ref="my-modal" hide-footer :title="modalMessage">
      <p class="my-4">
        Please
        <router-link
          :to="{
            name: 'login',
            query: { redirect: getRedirectRoute },
          }"
        >
          <a>LOGIN</a>
        </router-link>
        or
        <router-link :to="{ name: 'signup' }">
          <a>SIGN UP</a>
        </router-link>
        for project spectrum.
      </p>
    </b-modal>
    <!-- End Login Modal -->
  </div>
</template>
<script>
import axios from 'axios';
import { BPagination, BFormInput } from 'bootstrap-vue';
import { isLoggedIn, handleApiError } from '../../utils/authentication';
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
import { EventBus } from "../../utils/eventBus";
export default {
  name: 'courses-training',
  components: {
    BPagination,
    BFormInput,
    PageHeader,
    PageHeaderTitleContent,
  },
  props: {
    query: String,
  },
  data() {
    return {
      tabIndex: 0,
      searchQuery: this.query,
      blogItems: [],
      blogItemCount: 0,
      currentPage: 1,
      perPage: 9,
      items: [],
      modalMessage: '',
      loginToBookmarkMessage: 'Want to bookmark this for later?',
      loginToAccessMessage: 'Want to access additional content?',
    };
  },
  computed: {
    getRedirectRoute() {
      return '/training-videos';
    },
    displayedItems() {
      return this.itemsFromSearchQuery.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    itemsFromSearchQuery() {
      if (this.searchQuery) {
        return this.items.filter((item) => {
          return this.searchQuery
            .toLowerCase()
            .split(' ')
            .every(
              (v) =>
                item.title.toLowerCase().includes(v) ||
                item.source.toLowerCase().includes(v)
            );
        });
      } else {
        return this.items;
      }
    },
    totalRows() {
      return this.itemsFromSearchQuery.length;
    },
  },
  mounted: async function () {
    EventBus.$emit("activate-indicated-menu-item", "Courses/Videos");
    this.init();
    this.getBlogPosts(); // async
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
    itemHref(item) {
      return item.auth && !isLoggedIn()
        ? '/#/login?redirect=/training-videos'
        : item.trainingVideoRecordingLink;
    },
    itemTarget(item) {
      return item.auth && !isLoggedIn() ? '' : '_blank';
    },
    async getBlogPosts() {
      var training = await this.getTrainingPosts();
      var trainingAuth = await this.getAuthTrainingPosts();
      this.items = training.concat(trainingAuth);
    },
    pageClicked() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    /**
     * NO AUTH Training Videos
     * API call to server: GET /api/resources/trainingVideos
     */
    async getTrainingPosts() {
      var items = [];
      // await axios
      //   .get('/api/resources/trainingVideos')
      //   .then((response) => {
      //     items = response.data.Items.map((obj) => ({ ...obj, auth: false }));
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
      return items;
    },
    /**
     * AUTH Training Videos
     * API call to server: GET /api/resources/trainingVideosAuthenticated
     */
    async getAuthTrainingPosts() {
      var items = [];
      await axios
        .get('/api/resources/trainingVideosAuthenticated')
        .then((response) => {
          items = response.data.Items.map((obj) => ({ ...obj, auth: true }));
        })
        .catch((error) => {
          console.error(error);
        });
      return items;
    },
    isLocked(item) {
      return item.auth && !isLoggedIn();
    },
    showLoginModal() {
      this.modalMessage = this.loginToAccessMessage;
      this.$refs['my-modal'].show();
    },
    onBookmarkPage(item) {
      //console.log('Bookmark Page', item);
      if (!isLoggedIn()) {
        console.warn('Not Logged In');
        this.modalMessage = this.loginToBookmarkMessage;
        this.$refs['my-modal'].show();
      } else {
        this.bookmarkPage(item);
      }
    },
    async bookmarkPage(item) {
      const url = item.trainingVideoRecordingLink;
      const title = item.title;
      const type = 'video';
      //console.log('Bookmarking', url, title, type);

      axios
        .post(`/api/bookmark`, {
          url: url,
          title: title,
          type: type,
        })
        .then(async (response) => {
          //console.log('Bookmark Response', response);
          // Set selected as bookmarked
          const updatedItems = await Promise.all(
            this.items.map(async (training) => {
              if (training.id == item.id) {
                training.isPageBookmarked = true;
              }
              return training;
            })
          );
          this.items = updatedItems;
        })
        .catch((error) => {
          handleApiError(error, this.$router);
        });
    },
  },
};
</script>
<style scoped>
.inner-header-bg {
  background-image: url('~@/assets/images/headers/training.png');
  background-position: center center;
}
#blog-pagination li {
  margin: 0px;
}

.cover {
  object-fit: cover;
  height: 225px;
  width: 100%;
}

.float-right-bottom {
  position: absolute;
  bottom: 40px;
  right: 20px;
}
</style>
